import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { environment } from '../environments/environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  try {
    const account = authService.getActiveAccount();

    if (!account) {
      return next(req);
    }

    return from(authService.getAccessToken()).pipe(
      switchMap((token) => {
        const tenantUserId = authService.getTenantUserId();

        const requestHeaders: Record<string, string> = {
          Authorization: `Bearer ${token}`,
        };

        if (tenantUserId != null) {
          requestHeaders['X-Tenant-User-Id'] = tenantUserId.toString();
        }

        const callerObjectId = account.idTokenClaims?.['oid'];

        const isLocalApi =
          environment.apiUrl.startsWith('http://localhost:') || environment.apiUrl.startsWith('https://localhost:');

        if (isLocalApi && callerObjectId) {
          requestHeaders['X-Caller-ObjectId'] = String(callerObjectId);
        }

        const clonedReq = req.clone({
          setHeaders: requestHeaders,
        });

        return next(clonedReq);
      })
    );
  } catch (error) {
    console.log('⚠️ MSAL not initialized, proceeding without token');

    return next(req);
  }
};
